import { render, staticRenderFns } from "./Foot1830.vue?vue&type=template&id=7012de24"
import script from "./Foot1830.vue?vue&type=script&lang=js"
export * from "./Foot1830.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports